
import React ,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { withRouter }         from 'react-router-dom';
import { connect }            from 'react-redux';
import { Form, Input, Button, message, Spin, Checkbox } from "antd";

// import CreateReport from '../EachAccount/eachaccount';

import wasabiDarkLogo from '../../../assets/logo/wasabi_header_logo_dark.png';

import "./addNewAccount.scss";

class AddNewAccount extends Component{
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    
    render(){
        return(
            <div className="add-new-account-container">
                <div className="content-box">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo} />
                    </div>

                    <div className="add-account-form">
                        <Form
                        layout="horizontal"
                        // onSubmit={this.handleSubmit.bind(this)}
                        className="account-form">
                            <Form.Item>
                                <Input 
                                    placeholder="Account Name"
                                    className="account-input"
                                />
                                {/* {getFieldDecorator('user')(
                                    <Input 
                                        placeholder="Email"
                                        className="login-input"
                                    />
                                )} */}
                            </Form.Item>
                            <Form.Item>
                                <Input 
                                    placeholder="Description"
                                    type="text"
                                    className="account-input"
                                />
                                {/* {getFieldDecorator('password')(
                                    <Input 
                                        placeholder="Password"
                                        type="password"
                                        className="login-input"
                                    />
                                )} */}
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    className="account-btn"
                                    type="primary"
                                    size="large"
                                    loading={this.state.loading}
                                    htmlType="submit"
                                    block>
                                    Add New Account
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(
    connect(
    //   mapStateToProps,
    //   mapDispatchToProps
    )(AddNewAccount)
  );